import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.widget.fund.info');
import { OnInit, AfterViewInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { ElementRef, ViewChild } from '@angular/core';
import { ClassicEditor, CKEditorPlugins } from "src/libs/portal/season/ckeditor";
import $ from "jquery";

@Component({
    selector: 'wiz-portal-lpsysadmin-widget-fund-info',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.lpsysadmin.widget.fund.info/view.scss */
.form-control-flush {
  text-align: left !important;
}`],
})
export class PortalLpsysadminWidgetFundInfoComponent implements OnInit, AfterViewInit {
    constructor(@Inject( Service) public service: Service) { }

    @ViewChild('editor')
    public editorElement: ElementRef;

    @Input() fund: any;
    @Input() investments: any;
    @Input() visibility: any;

    public editor: any;
    public editorReady: boolean = false;
    private legacyMigrated: boolean = false;

    private visibilityKeys: string[] = [
        'total_amount', 'gp_string', 'amount_per_share', 'payment_method',
        'registered_date', 'registration_date', 'expiration_date', 'exit_date',
        'deposit_date', 'submission_date', 'investment_resource', 'type',
        'category', 'unique_number', 'account', 'report_frequency',
        'max_lp_count', 'manager', 'key_staff', 'sum_investment', 'auditor',
        'operating_period', 'target_field', 'max_share_count', 'min_share_count'
    ];

    public async ngOnInit() {
        await this.service.init();
        this.normalizeFund();
        await this.setVisibility();
        this.calculateInvestmentSum();
        await this.service.render();
    }

    public async ngAfterViewInit() {
        await this.initEditor();
    }

    private toObject(value: any) {
        if (value && typeof value === 'object' && !Array.isArray(value)) return value;
        if (typeof value === 'string' && value.trim()) {
            try {
                const parsed = JSON.parse(value);
                if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) return parsed;
            } catch (error) { }
        }
        return {};
    }

    private toList(value: any) {
        return Array.isArray(value) ? value : [];
    }

    private normalizeMgmtRate(value: any) {
        let source = value;
        if (typeof source === 'string' && source.trim()) {
            try {
                source = JSON.parse(source);
            } catch (error) {
                source = source.split(',').map((item: string) => item.trim());
            }
        }
        if (!Array.isArray(source)) source = [];

        const result = source.map((item: any) => {
            if (item && typeof item === 'object') {
                return {
                    base: item.base || '결성총액',
                    rate: item.rate || ''
                };
            }
            return {
                base: '결성총액',
                rate: item === null || item === undefined || item === 'null' ? '' : item
            };
        });

        while (result.length < 8) result.push({ base: '결성총액', rate: '' });
        return result.slice(0, 8);
    }

    private normalizeBaseRate(value: any) {
        if (typeof value === 'string' && value.trim()) {
            try {
                const parsed = JSON.parse(value);
                if (parsed && typeof parsed === 'object') return {
                    type: parsed.type || 'IRR',
                    value: parsed.value || ''
                };
            } catch (error) { }
        }
        if (value && typeof value === 'object') return {
            type: value.type || 'IRR',
            value: value.value || ''
        };
        return { type: 'IRR', value: value || '' };
    }

    private splitLegacyNames(value: any, mapper: Function) {
        if (!value) return [];
        return `${value}`
            .split(',')
            .map((name: string) => name.trim())
            .filter((name: string) => !!name)
            .map((name: string) => mapper(name));
    }

    private normalizeFund() {
        if (!this.fund) this.fund = {};

        if (!this.fund.extra) this.fund.extra = {};
        this.fund.extra = this.toObject(this.fund.extra);
        this.visibility = this.toObject(this.visibility || this.fund.visibility);

        if (this.fund.isnew && !this.fund.id) this.fund.id = 'new';
        if (!this.fund.investment_status) this.fund.investment_status = '결성';
        if (!this.fund.investment_stage) this.fund.investment_stage = '참여신청';
        if (!this.fund.payment_method) this.fund.payment_method = '일시납';
        if (!this.fund.investment_resource) this.fund.investment_resource = '민간';
        if (!this.fund.type) this.fund.type = '개투';
        if (!this.fund.category) this.fund.category = '블라인드';
        if (!this.fund.extra.fund_info) this.fund.extra.fund_info = '';
        if (!this.fund.extra.mgmt_frequency) this.fund.extra.mgmt_frequency = 'annual';
        if (this.fund.extra.account_name === undefined || this.fund.extra.account_name === null) {
            this.fund.extra.account_name = this.fund.name || '';
        }

        this.fund.extra.gps = this.toList(this.fund.extra.gps);
        this.fund.extra.key_staff_list = this.toList(this.fund.extra.key_staff_list);
        this.fund.extra.managers = this.toList(this.fund.extra.managers);
        this.fund.mgmt_rate = this.normalizeMgmtRate(this.fund.mgmt_rate);
        this.fund.base_rate = this.normalizeBaseRate(this.fund.base_rate);

        if (!this.legacyMigrated) {
            if (this.fund.extra.gps.length === 0 && this.fund.gp_string) {
                this.fund.extra.gps = this.splitLegacyNames(this.fund.gp_string, (name: string) => ({ name, phone: '', note: '' }));
            }
            if (this.fund.extra.key_staff_list.length === 0 && this.fund.key_staff) {
                this.fund.extra.key_staff_list = this.splitLegacyNames(this.fund.key_staff, (name: string) => ({ name, role: '', phone: '' }));
            }
            if (this.fund.extra.managers.length === 0 && this.fund.manager) {
                this.fund.extra.managers = this.splitLegacyNames(this.fund.manager, (name: string) => ({ name, position: '', phone: '' }));
            }
            this.legacyMigrated = true;
        }

        if (this.fund.isnew) {
            for (let key of this.visibilityKeys) {
                if (this.visibility[key] === undefined) this.visibility[key] = true;
            }
        }

        this.fund.visibility = this.visibility;
    }

    private calculateInvestmentSum() {
        if (!Array.isArray(this.investments)) this.investments = [];
        let sum = 0;
        for (let i = 0; i < this.investments.length; i++) {
            if (this.investments[i].investment_amount) {
                sum += this.investments[i].investment_amount * 1;
            }
        }
        this.fund.sum_investment = this.service.formatter.currency(sum);
    }

    private async initEditor() {
        if (!this.editorElement) return;
        let element: any = this.editorElement.nativeElement;

        if (!this.editor && $(element).parent().find(".ck-content").length == 0) {
            let toolbar = 'heading | bold italic strikethrough underline | blockQuote code | bulletedList numberedList | outdent indent | uploadImage insertTable link codeBlock horizontalLine | specialCharacters'.split(' ');

            this.editor = await ClassicEditor.create(element, {
                toolbar: {
                    items: toolbar,
                    shouldNotGroupWhenFull: true
                },
                removePlugins: ["MediaEmbedToolbar"],
                plugins: CKEditorPlugins,
                simpleUpload: {
                    uploadUrl: '/file/upload'
                }
            });
        }

        if (this.editor) {
            this.editor.data.set(this.fund.extra.fund_info || '');
        }

        this.editorReady = true;
        await this.service.render();
    }

    public async setVisibility() {
        this.visibility = this.toObject(this.visibility);
        this.fund.visibility = this.visibility;
        await this.service.render();
    }

    public async addGP() {
        if (!this.fund.extra) this.fund.extra = {};
        if (!this.fund.extra.gps) this.fund.extra.gps = [];
        this.fund.extra.gps.push({ name: '', phone: '', note: '' });
        await this.service.render();
    }

    public async removeGP(index: number) {
        const ok = await this.alert("GP를 삭제하시겠습니까?", "error", "취소", "삭제");
        if (!ok) return;
        this.fund.extra.gps.splice(index, 1);
        await this.service.render();
    }

    public async addKeyStaff() {
        if (!this.fund.extra) this.fund.extra = {};
        if (!this.fund.extra.key_staff_list) this.fund.extra.key_staff_list = [];
        this.fund.extra.key_staff_list.push({ name: '', role: '', phone: '' });
        await this.service.render();
    }

    public async removeKeyStaff(index: number) {
        const ok = await this.alert("핵심운용인력을 삭제하시겠습니까?", "error", "취소", "삭제");
        if (!ok) return;
        this.fund.extra.key_staff_list.splice(index, 1);
        await this.service.render();
    }

    public async addManager() {
        if (!this.fund.extra) this.fund.extra = {};
        if (!this.fund.extra.managers) this.fund.extra.managers = [];
        this.fund.extra.managers.push({ name: '', position: '', phone: '' });
        await this.service.render();
    }

    public async removeManager(index: number) {
        const ok = await this.alert("대표펀드매니저를 삭제하시겠습니까?", "error", "취소", "삭제");
        if (!ok) return;
        this.fund.extra.managers.splice(index, 1);
        await this.service.render();
    }

    public async update() {
        this.normalizeFund();
        let body = JSON.parse(JSON.stringify(this.fund));
        body.visibility = this.visibility;
        body.mgmt_rate = JSON.stringify(body.mgmt_rate);
        body.base_rate = JSON.stringify(body.base_rate);
        const fundInfo = this.editor ? this.editor.data.get() : (body.extra.fund_info || '');
        body.extra.fund_info = fundInfo.replace(/\n/g, "<br />");
        delete body.sum_investment;
        delete body.fundraising;
        delete body.fundraising_member;

        // Sync multi-entry arrays to legacy single string fields
        if (body.extra.gps && body.extra.gps.length > 0) {
            body.gp_string = body.extra.gps.map((g: any) => g.name).filter((n: string) => n).join(', ');
        } else {
            body.gp_string = '';
        }
        if (body.extra.key_staff_list && body.extra.key_staff_list.length > 0) {
            body.key_staff = body.extra.key_staff_list.map((k: any) => k.name).filter((n: string) => n).join(', ');
        } else {
            body.key_staff = '';
        }
        if (body.extra.managers && body.extra.managers.length > 0) {
            body.manager = body.extra.managers.map((m: any) => m.name).filter((n: string) => n).join(', ');
        } else {
            body.manager = '';
        }

        const { code, data } = await wiz.call("update", { info: JSON.stringify(body) });
        if (code == 200) await this.alert("저장되었습니다", "success");
        else if (code == 201) {
            await this.service.href(`/admin/invest/fund/formed/${data}/info`);
            location.reload();
            return
        }
        else await this.alert("오류가 발생했습니다. 다시 저장해주세요.", "error");
        await this.service.render();
    }

    public async setFundStatus(status: string) {
        this.fund.investment_status = status;
        if (status === '결성' && !this.fund.investment_stage) this.fund.investment_stage = '참여신청';
        await this.service.render();
    }

    public async setInvestmentStage(stage: string) {
        this.fund.investment_stage = stage;
        await this.service.render();
    }

    public async setMgmtFrequency(frequency: string) {
        this.fund.extra.mgmt_frequency = frequency;
        await this.service.render();
    }

    public async clearValue(obj, key) {
        obj[key] = null;
        await this.service.render();
    }

    public async upload(item, target) {
        let files = await this.service.file.select();
        if (files.length == 0) return;

        let fd = new FormData();
        fd.append('upload', files[0]);
        let fdurl = '/file/upload';
        const { url } = await this.service.file.upload(fdurl, fd, async (percent: number, total: number, position: number) => { });
        item[target] = url;
        await this.service.render();
        await this.service.render();
    }

    public activeClass(target: string, status: string) {
        if (target == status) {
            return "group flex gap-x-3 mr-2 rounded-full bg-zinc-600 px-3.5 py-2 text-sm font-semibold text-white hover:bg-zinc-800 ";
        }
        return "group flex gap-x-3 rounded-md mr-2 py-2 pl-2 pr-3 text-sm font-semibold leading-6 text-zinc-700 hover:bg-zinc-50 hover:text-blue-600";
    }

    public async alert(message: string, status: string = 'error', cancel: any = false, action: string = '확인') {
        return await this.service.alert.show({
            title: "",
            message: message,
            cancel: cancel,
            actionBtn: status,
            action: action,
            status: status
        });
    }

    public async titleChanged() {
        this.fund.extra.account_name = this.fund.name;
        await this.service.render();
    }
}

export default PortalLpsysadminWidgetFundInfoComponent;